module.exports = __webpack_public_path__ + "img/optimonk-ai-logo.3af851ca.svg";